import React from 'react'
import { Loader2 } from 'lucide-react'

import { LOGIN_URL, redirectToLogin } from '../../stores/useSessionStore'

/**
 * Shown when there is no valid session. EMS has no login form of its own — sign-in
 * happens on the SSO app — so this exists only to bounce the user there and to give
 * them something to click if the automatic redirect cannot run.
 */
export const SsoRedirect: React.FC = () => {
  React.useEffect(() => {
    redirectToLogin()
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-sm w-full text-center space-y-6">
        <img
          className="mx-auto h-24 w-auto"
          src="/AG-Logo.png"
          alt="AuthentiGATE"
        />
        <div className="space-y-2">
          <h1 className="text-lg font-semibold text-gray-900">
            Employee and Credential Management System
          </h1>
          {LOGIN_URL ? (
            <p className="text-sm text-muted-foreground inline-flex items-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              Redirecting you to sign in...
            </p>
          ) : (
            <p className="text-sm text-destructive">
              No sign-in URL is configured for this environment.
            </p>
          )}
        </div>
        {LOGIN_URL && (
          <a
            href={LOGIN_URL}
            className="text-sm text-primary underline underline-offset-4"
          >
            Continue to sign in
          </a>
        )}
      </div>
    </div>
  )
}
